import React from 'react';
import classNames from 'classnames';

import ButtonPublic from '@shared/components/ui/ButtonPublic';
import { ENGAGE_CARDS } from '../../constants';

import styles from './styles.module.css';

import { track } from '@/shared/analytics/track';

const handleBookACallClick = (): void => {
  track('book_a_call_clicked', { location: 'engage_band' });
};

const EngageBand: React.FC = () => (
  <section className={styles.engage} id="engage">
    <div className={styles.shell}>
      <div className={styles.head}>
        <div className={styles.eyebrow}>Two ways to engage</div>
        <h2 className={styles.heading}>
          Talk to us, or <em>explore on your own.</em>
        </h2>
      </div>

      <div className={styles.grid}>
        {ENGAGE_CARDS.map((card) => {
          const isGuided = card.variant === 'guided';

          return (
            <article
              key={card.number}
              className={classNames(styles.card, {
                [styles.cardPrimary]: isGuided
              })}
            >
              <span
                className={classNames(styles.badge, {
                  [styles.badgePrimary]: isGuided,
                  [styles.badgeDark]: !isGuided
                })}
              >
                {card.badge}
              </span>
              <div className={styles.cardNumber}>{card.number}</div>
              <h3 className={styles.cardHeading}>{card.title}</h3>
              <p className={styles.cardDesc}>{card.description}</p>
              <ul className={styles.bullets}>
                {card.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
              <div className={styles.actions}>
                <ButtonPublic
                  as="a"
                  href={card.ctaHref}
                  target={isGuided ? '_blank' : undefined}
                  variant="primary"
                  className={isGuided ? styles.btnOnSage : undefined}
                  onClick={isGuided ? handleBookACallClick : undefined}
                >
                  {card.ctaLabel}
                </ButtonPublic>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  </section>
);

export default EngageBand;
